export default __webpack_public_path__ + "static/media/how_work.9a306068.png";